export default {
    industries: [],
    jobs: [],
    search_jobs: [],
    search: false,
    jobAppliedSuccessful: false,
    jobAppliedFail: false,
    alreadyApplied: false,
    searchFilters: {}
};